module.exports = __webpack_public_path__ + "img/2021-4.e656e5f6.jpg";